import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@components/ProtectedRoute";
import { AppLayout } from "@components/Layout";
import Home from "@pages/Home";
import PreviewPage from "@pages/PreviewPage";
import Dashboard from "@pages/Dashboard";
import Scrapers from "@pages/Scrapers";
import ScraperForm from "@pages/ScraperForm";
import Logs from "@pages/Logs";
import Account from "@pages/Account";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/preview", element: <PreviewPage /> },
      { path: "/account", element: <Account /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/scrapers", element: <Scrapers /> },
          { path: "/scrapers/new", element: <ScraperForm /> },
          { path: "/scrapers/:id/edit", element: <ScraperForm /> },
          { path: "/logs", element: <Logs /> },
        ],
      },
    ],
  },
]);
